import React from 'react'
import SadFace from 'hec/assets/icons/sad-face'
import {Heading} from '@/components/ui/heading'
import {BodyCopy} from '@/components/ui/body-copy'

const FailedQuizBlock = () => (
    <div
        className="flex flex-col items-center py-[3.25rem] bg-red-01/30 rounded-md"
        name="quiz-block-result"
    >
        <SadFace />
        <Heading
            tag="h4"
            variant="h4"
            className="mt-5 mb-2 text-emphasis"
            data-testid="failedQuizBlock-Heading"
        >
            Oops!
        </Heading>
        <BodyCopy size="large" className="text-emphasis" data-testid="failedQuizBlock-BodyCopy">
            Let’s make sure you answer all of the questions correctly!
        </BodyCopy>
    </div>
)

export default FailedQuizBlock
